import { startsWith } from 'lodash';
import Enumerator from './Enumerator';

export const paymentFrequencies = [
  'none',
  'weekly',
  'fortnightly',
  'monthly',
  'quarterly',
  'semiannual',
  'annually'
];

export class PaymentFrequency extends Enumerator {
  static default(isNone) {
    return isNone ? this.of('none') : this.of('monthly');
  }

  static of(option?: string) {
    let correctOption = option;
    const isNone = startsWith(correctOption, 'f') || startsWith(correctOption, 'o');
    switch (option) {
      case '4.333':
      case 'f52':
      case 'o1':
        correctOption = 'weekly';
        break;
      case '2.17':
      case 'f26':
      case 'o2':
        correctOption = 'fortnightly';
        break;
      case '1':
      case 'f12':
      case 'o3':
        correctOption = 'monthly';
        break;
      case '0.333':
      case 'f4':
        correctOption = 'quarterly';
        break;
      case '0.167':
      case 'f2':
        correctOption = 'semiannual';
        break;
      case '0.083':
      case 'f1':
        correctOption = 'annually';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default(isNone);
  }

  static getFrequencyValue(value?: string, isExpense?: boolean) {
    let out = 1;
    switch (value) {
      case 'weekly':
        out = isExpense ? 4.3333333333 : 52;
        break;
      case 'fortnightly':
        out = isExpense ? 2.1666666667 : 26;
        break;
      case 'monthly':
        out = isExpense ? 1 : 12;
        break;
      case 'quarterly':
        out = isExpense ? 0.3333333333 : 4;
        break;
      case 'semiannual':
        out = isExpense ? 0.1666666667 : 2;
        break;
      case 'annually':
        out = isExpense ? 0.0833333333 : 1;
        break;
      default:
        break;
    }
    return out;
  }
}

PaymentFrequency.initEnum({
  none: {
    get title() {
      return 'Select one';
    },
    get weight() {
      return 0;
    }
  },
  weekly: {
    get title() {
      return 'Weekly';
    },
    get weight() {
      return 1;
    }
  },
  fortnightly: {
    get title() {
      return 'Fortnightly';
    },
    get weight() {
      return 2;
    }
  },
  monthly: {
    get title() {
      return 'Monthly';
    },
    get weight() {
      return 3;
    }
  },
  quarterly: {
    get title() {
      return 'Quarterly';
    },
    get weight() {
      return 4;
    }
  },
  semiannual: {
    get title() {
      return 'Semiannual';
    },
    get weight() {
      return 5;
    }
  },
  annually: {
    get title() {
      return 'Annually';
    },
    get weight() {
      return 6;
    }
  }
});

export default {
  paymentFrequencies,
  PaymentFrequency
};
